import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useOpenLiveChat } from '@hub/hooks';
import { useTheme } from '@mui/material';
import { Button, Stack, Typography } from '@monorepo/nova-ui';
import { useStore } from '../../helpers/use-store';

export const MailRejected = ({
  isLoading,
  message,
}: {
  isLoading: boolean;
  message: ReactNode;
}) => {
  const {
    dataStore: { userStore },
  } = useStore();

  const theme = useTheme();
  const { t } = useTranslation(['mailConfirmationNova']);
  const openLiveChat = useOpenLiveChat({ flow: 'mail-rejected' });

  return (
    <Stack textAlign="center" direction={'column'} gap={5}>
      <Typography variant={'h3'} textAlign="center">
        {t('mailConfirmationNova:oops_title')}
      </Typography>
      <Typography textAlign="center">{message}</Typography>
      <Typography
        bgcolor={theme.palette.background.contrast}
        variant={'h6'}
        borderRadius={24}
        color={theme.palette.secondaryInvert.main}
      >
        {userStore.currentUser.email}
      </Typography>
      <Stack direction={'row'} justifyContent={'center'}>
        <Button
          size={'lg'}
          variant={'outlined'}
          loading={isLoading}
          onClick={openLiveChat}
        >
          {t('mailConfirmationNova:contact_support')}
        </Button>
      </Stack>
    </Stack>
  );
};
